import { NikkeIcon } from '../../nikke-icons/shared/NikkeIcon.jsx';

const FALLBACK_LABELS = {
  작열: '화',
  수냉: '수',
  전격: '전',
  풍압: '풍',
  철갑: '철',
};

export function ElementIcon({ element, imageUrl = '', className = '', title = '', loading = 'lazy' }) {
  const normalizedElement = String(element || '').trim();
  const label = title || normalizedElement || '속성';

  return (
    <NikkeIcon
      type="element"
      loading={loading}
      iconKey={normalizedElement}
      aliases={[normalizedElement]}
      label={label}
      imageUrl={imageUrl}
      fallbackText={FALLBACK_LABELS[normalizedElement] || '?'}
      className={`shared-element-icon ${className}`.trim()}
    />
  );
}
